/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Frontrow_PickInputs */

const en_scene_frontrow_pick = /** @type {(inputs: Scene_Frontrow_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a time`)
};

/**
* | output |
* | --- |
* | "Pick a time" |
*
* @param {Scene_Frontrow_PickInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_frontrow_pick = /** @type {((inputs?: Scene_Frontrow_PickInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Frontrow_PickInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_frontrow_pick(inputs)
});